import { FilterFilled, PlusOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { ASC, DESC, ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { getPaginationState } from 'react-jhipster';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Container } from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Checkbox, Dropdown, Input, Menu, Space, Tooltip } from 'antd';
import ModalConfirmComponent from 'app/shared/component/modal/confirm';
import TableComponent from 'app/shared/component/table/table';
import { deleteEntity, getEntities } from '../activities.reducer';
import { columns } from './config';
// import { hasPermissions } from 'app/shared/util/permissions';
import { APP_LOCAL_DATE_FORMAT_PAYLOAD } from 'app/config/constants';
import { IActivitiesView } from 'app/shared/model/activities/activities.model';
import { OrderByType } from 'app/shared/model/enum/order-type.enum';
import dayjs from 'dayjs';
import ActivitiesUpdate from '../form/activities-update';
import ReportActivities from '../form/report/form/reportActivities';
import ReportActivitiesResult from '../form/report/view/reportActivitiesResult';
import FilterModal from './filter/filter';

const { Search } = Input;

export const ActivitiesView = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const pageLocation = useLocation();
  const { filter } = pageLocation.state || {};
  const { id } = useParams();
  const searchParams = new URLSearchParams(pageLocation.search);

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'lastModifiedDate', DESC), pageLocation.search),
  );

  const activitiesList = useAppSelector(state => state.activities.entities);
  const totalRecord = useAppSelector(state => state.activities.totalItems);

  const [visibleConfirmDelete, setVisibleConfirmDelete] = useState(false);
  const [idDeletedActivities, setIdDeletedActivities] = useState(null);
  const [idSelected, setIdSelected] = useState(null);
  const [visibleFilter, setFilterModalVisible] = useState(false);
  const [visibleModalReport, setVisibleModalReport] = useState(false);
  const [visibleModalReportResult, setVisibleModalReportResult] = useState(false);

  const [searchText, setSearchText] = useState();
  const [filters, setFilter] = useState<any>(filter);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [checkedList, setCheckedList] = useState<string[]>(['action']);
  const [columnConfig, setColumnConfig] = useState<any[]>([]);
  const [source, setSource] = useState<IActivitiesView[]>([]);
  const [isOpenModalFormActivities, setOpenModalFormActivities] = useState(false);

  const dropDownKr = [
    {
      key: '1',
      label: 'Báo cáo kết quả thực hiện',
      onclick: item => handleUpdateReport(item),
      show: true, //isAdmin || activitiesPermissions.Add,
    },
    {
      key: '2',
      label: 'Danh sách kết quả thực hiện',
      onclick: item => handleViewReportResult(item),
      show: true, //isAdmin || krPermissions.UpdateWeight,
    },
  ];

  const columnDefault = [
    {
      title: 'Mã',
      sorter: true,
      key: 'code',
      width: 60,
      fixed: 'left',
      render: value => (
        <Space size="middle">
          <Dropdown trigger={['contextMenu']} overlay={<CustomMenu value={value} />}>
            <div className="d-flex justify-content-center align-items-center">{value.code}</div>
          </Dropdown>
        </Space>
      ),
    },
    ...columns,
  ]

  const newColumns = columnConfig.map(item => ({
    ...item,
    hidden: !checkedList.includes(item.key),
  }));

  useEffect(() => {
    setCheckedList([...checkedList, ...columnDefault.map(x => x.key)]);
  }, []);

  useEffect(() => {
    setColumnConfig(createColumns());
  }, [checkedList]);

  useEffect(() => {
    getAllEntities();
  }, [paginationState, filters]);

  useMemo(() => {
    setSource(activitiesList);
  }, [activitiesList]);

  const CustomMenu = ({ value }) => (
    <Menu>
      {dropDownKr.map(
        item =>
          item.show && (
            <Menu.Item key={item.key} onClick={() => item.onclick(value)}>
              {item.label}
            </Menu.Item>
          ),
      )}
    </Menu>
  );

  const createColumns = () => {
    const column = [];
    column.push({
      key: 'action',
      fixed: 'left',
      width: 80,
      filterDropdown: () => (
        <Checkbox.Group
          className="d-grid gap-3 p-3 overflow-auto height-350 align-items-center"
          value={checkedList}
          options={[...columnDefault].map(x => {
            return {
              label: x.title,
              value: x.key,
            };
          })}
          onChange={handleAddColumnView}
        />
      ),
      filterIcon: () => <FilterFilled style={{ color: checkedList.length > 0 ? '#1890ff' : undefined }} />,
      render: (item: any) =>
        !item.activitiesId && (
          <div className="action">
            <span className="action-edit">
              {true /*(isAdmin || activitiesPermissions.Update)*/ && (
                <Tooltip title="Sửa">
                  <FontAwesomeIcon
                    onClick={() => {
                      handleOpenModalFormActivities(item.id);
                    }}
                    icon="pencil-alt"
                  />
                </Tooltip>
              )}
            </span>
            <span className="action-delete">
              {true /*(isAdmin || activitiesPermissions.Delete)*/ && (
                <Tooltip title="Xóa">
                  <FontAwesomeIcon
                    onClick={() => {
                      handleWarningDeleteItem(item.id);
                    }}
                    icon="trash"
                  />
                </Tooltip>
              )}
            </span>
          </div>
        ),
    });

    return [...column, ...columnDefault];
  };

  const handleAddColumnView = values => {
    setCheckedList([...values, 'action']);
  };


  const getAllEntities = async (value?: string, filtersRequest?: any) => {
    await dispatch(
      getEntities({
        searchText: value ?? searchText,
        page: paginationState.activePage,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
        accountableId: filtersRequest?.accountableId,
        dueDate: filtersRequest?.dueDate && dayjs(filtersRequest.dueDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
        field: filtersRequest?.field,
        alignId: filtersRequest?.alignId,
        reportScheduleId: filtersRequest?.reportScheduleId,
        projectId: filtersRequest?.projectId,
        startDate: filtersRequest?.startDate && dayjs(filtersRequest.startDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
        workPriorityLevel: filtersRequest?.workPriorityLevel,
        workStatus: filtersRequest?.workStatus,
        workTypeId: filtersRequest?.workTypeId,
        objectiveId: id
      }),
    );
  };

  useEffect(() => {
    getAllEntities();
  }, []);

  const handleChange = (pageNumber: number, size: number, sorter: any) => {
    const { order, sort } = paginationState;
    setPaginationState({
      ...paginationState,
      order: Object.keys(sorter).length !== 0 ? (sorter.order && OrderByType[sorter.order] === OrderByType.descend ? DESC : ASC) : order,
      sort: Object.keys(sorter).length !== 0 ? sorter.columnKey : sort,
      activePage: pageNumber,
      itemsPerPage: size,
    });
  };

  const handleFreeTextSearchQuery = query => {
    setSearchText(query);
    getAllEntities(query);
  };

  const handleWarningDeleteItem = (idRequest: number) => {
    setVisibleConfirmDelete(true);
    setIdDeletedActivities(idRequest);
  };

  const handleConfirmDelete = () => {
    if (idDeletedActivities) {
      dispatch(deleteEntity(idDeletedActivities))
        .then(() => {
          setExpandedRowKeys([]);
          getAllEntities();
        })
        .finally(() => {
          setVisibleConfirmDelete(false);
        });
    }
  };

  const getAllRowKeys = item => {
    return item.reduce((keys, value) => {
      keys.push(value.code);

      if (value.keyResults) {
        keys = keys.concat(getAllRowKeys(value.keyResults));
      }

      return keys;
    }, []);
  };

  const handleUpdateReport = item => {
    setIdSelected(item.id);
    setVisibleModalReport(true);
  };

  const handleCloseModalReportActivities = () => {
    setIdSelected(null);
    setVisibleModalReport(false);
  };

  const handleViewReportResult = item => {
    setIdSelected(item.id);
    setVisibleModalReportResult(true);
  };

  const handleCloseModalReportActivitiesResult = () => {
    setIdSelected(null);
    setVisibleModalReportResult(false);
  };

  const handleOpenModalFormActivities = (idRequest?: string) => {
    setIdSelected(idRequest);
    setOpenModalFormActivities(true);
  };

  const handleCloseModalFormActivities = (isReload = false) => {
    setIdSelected(null);
    setOpenModalFormActivities(false);
    if (isReload) {
      getAllEntities();
    }
  };

  return (
    <Container className="view">
      <div className="table">
        <div className="header">
          <Space className="search">
            <Search size="large" allowClear placeholder="Nhập giá trị tìm kiếm" onSearch={handleFreeTextSearchQuery} enterButton />
          </Space>
          <Space>
            {true /*(isAdmin || activitiesPermissions.Add)*/ && (
              <Button
                size="large"
                onClick={() => {
                  handleOpenModalFormActivities();
                }}
                className="primary"
                icon={<PlusOutlined />}
              >
                Thêm mới công việc
              </Button>
            )}
          </Space>
        </div>
        <TableComponent
          data={source.map((x, index) => {
            return {
              key: index + 1,
              ...x,
            };
          })}
          scroll={true}
          total={totalRecord}
          isFetching={false}
          columns={newColumns}
          tableLayout="fixed"
          expandedRowKeys={expandedRowKeys}
          setExpandedRowKeys={setExpandedRowKeys}
          handlePageChange={(pageNumber: number, size: number, search: any, sorter: any) => {
            handleChange(pageNumber, size, sorter);
          }}
        />
      </div>
      {visibleModalReportResult && (
        <ReportActivitiesResult
          isOpen={visibleModalReportResult}
          idSelected={idSelected}
          onClose={handleCloseModalReportActivitiesResult}
        />
      )}
      {visibleModalReport && (
        <ReportActivities isOpen={visibleModalReport} idSelected={idSelected} onClose={handleCloseModalReportActivities} />
      )}
      {isOpenModalFormActivities && (
        <ActivitiesUpdate isOpen={isOpenModalFormActivities} id={idSelected} onClose={handleCloseModalFormActivities} />
      )}
      <FilterModal visible={visibleFilter} onCancel={() => setFilterModalVisible(false)} />
      <ModalConfirmComponent
        visible={visibleConfirmDelete}
        onCancel={() => {
          setVisibleConfirmDelete(false);
        }}
        onConfirm={handleConfirmDelete}
        title={`Bạn có muốn xóa công việc`}
      />
    </Container>
  );
};

export default ActivitiesView;
